import { render, staticRenderFns } from "./AllCourseView.vue?vue&type=template&id=38d54bd1&scoped=true&"
import script from "./AllCourseView.vue?vue&type=script&lang=js&"
export * from "./AllCourseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d54bd1",
  null
  
)

export default component.exports